import katakanaWordOrder from './katakana_word_order.json';
import {WordOrder} from "./WordOrder";

export class KatakanaWordOrder extends WordOrder {
    protected rawWordOrder() {
        return katakanaWordOrder;
    }
}


// WEBPACK FOOTER //
// ./src/KatakanaWordOrder.ts